import React from 'react'
import { withStyles,withTheme } from '@material-ui/core/styles'

import Content from '../@react-fefmwk/theme-structure/modules/Content'
import ViewEntity from '../@react-fefmwk/entity/modules/ViewEntity'
import Modal from '../@react-fefmwk/modals/modules/Modal'
import ResetPasswordForm from '../@react-fefmwk/auth/modules/ResetPasswordForm'

import {idFromToken,displaynameFromToken} from '../@react-fefmwk/auth/services/token'

import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ChevronRight from '@material-ui/icons/ChevronRight'

const style = {}

class Profile extends React.Component {
    render() {
        const title = this.props.route.title

        const { classes } = this.props

        const id_user = idFromToken()
        const dispaly_name = displaynameFromToken()
        const user = {
            ID: id_user,
            user: dispaly_name
        }

        return <Content title={title}>
            <Grid container alignItems="center" spacing={2}>
                <Grid item xs="auto">
                    <Modal
                        maxWidth="sm"
                        fullWidth={true}
                        printCloseBtn
                        title="Reset password"
                        contentStyle={{}}
                        content={<Box mb={2}>
                            <ResetPasswordForm
                                user={user}
                                msgWelcome={(user) => <React.Fragment>
                                    Ciao {user.user},<br />
                                    inserisci la nuova password due volte.
                                </React.Fragment>}
                                msgAfterForgot="Password aggiornata. Torna al login per accedere"
                                buttons={(formikProps) => <React.Fragment>
                                    <Button color="primary" variant="contained" className={classes.resetBtn}
                                        disabled={!formikProps.isValid}
                                        type="submit"
                                    >Reset</Button>
                                </React.Fragment>}
                            />
                        </Box>}
                        Trigger={<Button color="secondary" endIcon={<ChevronRight />}>
                            Reset password
                        </Button>}
                    />
                </Grid>
            </Grid>
            <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} md={4}>
                    <ViewEntity
                        id_entity={id_user}
                        entity="users"
                    />
                </Grid>
            </Grid>
        </Content>
    }
}

export default withStyles(style)(withTheme(Profile))